import { debounce } from 'lodash';
import { useEffect, useState } from 'react';

export function useOnResizeValue<T = number>(predicate: () => T) {
  const [value, setValue] = useState(predicate());
  useEffect(() => {
    function onResize() {
      const newValue = predicate();
      setValue(newValue);
    }
    window.addEventListener('resize', debounce(onResize, 150));
    return () => window.removeEventListener('resize', onResize);
  }, [predicate]);

  return value;
}
